import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, watchEffect } from "vue";
import API from "@/api";
import message from "@arco-design/web-vue/es/message";
import dayjs from "dayjs";
import { REVIEW_STATUS_MAP } from "@/constant/appEnum";

import {
  addInterviewQuestionBankUsingPost,
  deleteInterviewQuestionBankUsingPost,
  getInterviewQuestionBankVoByIdUsingGet,
  listInterviewQuestionBankByPageUsingPost,
  updateInterviewQuestionBankUsingPost,
} from "@/request/api/interviewQuestionBankController";
import PictureUpload from "@/components/picture/PictureUpload.vue";
import { listAllInterviewQuestionUsingGet } from "@/request/api/interviewQuestionController";
import { batchUpdateInterviewQuestionBankUsingPost } from "@/request/api/interviewQuestionBankQuestionController";
//初始值

export default /*#__PURE__*/_defineComponent({
  __name: 'AdminInterviewQuestionBankPage',
  setup(__props) {

const initParams = {
  current: 1,
  pageSize: 10,
  sortOrder: "ascend",
  sortField: "createTime",
};
//搜索参数
const formParams = ref<API.InterviewQuestionBankQueryRequest>({
  ...initParams,
});
//传递参数
const searchParams = ref<API.InterviewQuestionBankQueryRequest>({});
//数据
const dataList = ref<API.InterviewQuestionBankVO[]>([]);
//总值
const total = ref<number>(0);
const loading = ref(false);
/**
 * 加载数据
 */
const loadData = async () => {
  loading.value = true;
  const response = await listInterviewQuestionBankByPageUsingPost(
    searchParams.value
  );
  if (response.data.code === 0) {
    dataList.value = response.data.data?.records || [];
    total.value = response.data.data?.total || 0;
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
  loading.value = false;
};
/**
 * 搜索
 */
const search = () => {
  searchParams.value = {
    ...initParams,
    ...formParams.value,
  };
};

/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  loadData();
});

/**
 * 当分页变化时，改变搜索条件，触发数据加载
 */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};
/**
 * 添加
 */
const addVisible = ref(false);
const add = async () => {
  addVisible.value = true;
};
//添加的数据
const addData = ref<API.InterviewQuestionBankAddRequest>({});

/**
 * 提交
 */
const addSubmit = async () => {
  const res = await addInterviewQuestionBankUsingPost(addData.value);
  if (res.data.code === 0) {
    loadData();
    message.success("添加成功");
    addVisible.value = false;
    addData.value = {};
  } else {
    message.error("添加失败，" + res.data.message);
  }
};

/**
 * 修改
 */
//旧的数据
const oldData = ref<API.InterviewQuestionBankVO>({});
const updateVisible = ref(false);
const update = async (id: number) => {
  updateVisible.value = true;
  const response = await getInterviewQuestionBankVoByIdUsingGet({
    id: id,
  });
  if (response.data.code === 0) {
    oldData.value = response.data.data || {};
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
};
const updateSubmit = async () => {
  updateVisible.value = true;
  const response = await updateInterviewQuestionBankUsingPost({
    ...oldData.value,
  });
  if (response.data.code === 0) {
    loadData();
    message.success("修改成功");
    updateVisible.value = false;
  } else {
    message.error("修改失败，" + response.data.message);
  }
};

/**
 * 删除
 */
const doDelete = async (id: number) => {
  if (!confirm("确定要删除吗？")) {
    return;
  }
  const res = await deleteInterviewQuestionBankUsingPost({ id });
  if (res.data.code === 0) {
    loadData();
  } else {
    message.error("删除失败，" + res.data.message);
  }
};
/**
 * 管理题库
 */
//所有题目
const allList = ref<any>([]);
//已存在的题目
const existList = ref();
const bankId = ref(0);

const manageVisible = ref(false);
const orderVisible = ref(false);
const batchLoading = ref(false);
// 打开管理界面
const manageBank = async (id: number) => {
  bankId.value = id;
  manageVisible.value = true;
  if (id == null || id == 0) {
    message.error("题库ID不能为空");
    manageVisible.value = false;
    return;
  }
  await loadListQuestion(id);
};

// 打开排序界面
const orderBank = async (id: number) => {
  bankId.value = id;
  orderVisible.value = true;
  if (id == null || id == 0) {
    message.error("题库ID不能为空");
    orderVisible.value = false;
    return;
  }
  await loadListQuestion(id);
};

const loadListQuestion = async (id: number) => {
  //搜索所有题目
  const res = await listAllInterviewQuestionUsingGet({
    bankId: 0,
  });
  if (res.data.code === 0 && res.data.data) {
    allList.value = res.data.data.map((item) => ({
      value: `${item.id}`,
      label: `${item.title}`,
    }));
  } else {
    message.error("加载数据失败，" + res.data.message);
  }
  //搜索已存在的题库内的题目
  const response = await listAllInterviewQuestionUsingGet({
    bankId: id,
  });
  if (response.data.code === 0 && response.data.data) {
    existList.value = response.data.data.map((item) => item.id);
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
};

/**
 * 保存题库
 */
const allSave = async () => {
  if (!confirm("确定要保存吗？")) {
    return;
  }
  batchLoading.value = true;
  const res = await batchUpdateInterviewQuestionBankUsingPost({
    id: bankId.value,
    idList: existList.value,
  });
  if (res.data.code === 0) {
    message.success("保存成功");
    manageVisible.value = false;
  } else {
    message.error("保存失败，" + res.data.message);
  }
  batchLoading.value = false;
};

const columns = [
  {
    title: "ID",
    dataIndex: "id",
  },
  {
    title: "用户ID",
    dataIndex: "userId",
  },
  {
    title: "标题",
    dataIndex: "title",
  },
  {
    title: "描述",
    dataIndex: "description",
  },
  {
    title: "题库图标",
    dataIndex: "picture",
    slotName: "picture",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    slotName: "createTime",
  },
  {
    title: "更新时间",
    dataIndex: "updateTime",
    slotName: "updateTime",
  },
  {
    title: "操作",
    slotName: "optional",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_transfer = _resolveComponent("a-transfer")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      model: formParams.value,
      layout: "inline",
      style: {"margin":"0 0 10px auto"},
      "label-align": "left",
      "auto-label-width": "",
      onSubmit: search
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "id",
          label: "ID："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: formParams.value.id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formParams.value.id) = $event)),
              placeholder: "请输入ID...",
              "allow-clear": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "userId",
          label: "用户ID："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: formParams.value.userId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formParams.value.userId) = $event)),
              placeholder: "请输入...",
              "allow-clear": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "title",
          label: "标题："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: formParams.value.title,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formParams.value.title) = $event)),
              placeholder: "请输入...",
              "allow-clear": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "description",
          label: "描述："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: formParams.value.description,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formParams.value.description) = $event)),
              placeholder: "请输入...",
              "allow-clear": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit",
              style: {"width":"120px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("搜索 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_space, { size: "large" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: add,
              style: {"margin":"5px","width":"100px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 添加题库 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "排序：" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_group, {
              modelValue: formParams.value.sortOrder,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formParams.value.sortOrder) = $event)),
              type: "button"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio, { value: "ascend" }, {
                  default: _withCtx(() => [
                    _createTextVNode("正序")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio, { value: "descend" }, {
                  default: _withCtx(() => [
                    _createTextVNode("倒序")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "排序字段：" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_group, {
              modelValue: formParams.value.sortField,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formParams.value.sortField) = $event)),
              type: "button"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio, { value: "createTime" }, {
                  default: _withCtx(() => [
                    _createTextVNode("创建时间")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio, { value: "updateTime" }, {
                  default: _withCtx(() => [
                    _createTextVNode("更新时间")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      _createVNode(_component_a_modal, {
        visible: addVisible.value,
        "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((addVisible).value = $event)),
        draggable: "",
        footer: false
      }, {
        title: _withCtx(() => [
          _createTextVNode(" 添加题库")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_a_form, { model: addData.value }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, { label: "标题" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      modelValue: addData.value.title,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((addData.value.title) = $event)),
                      placeholder: "请输入标题...",
                      "allow-clear": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "描述" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_textarea, {
                      modelValue: addData.value.description,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((addData.value.description) = $event)),
                      placeholder: "请输入描述...",
                      "allow-clear": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "题库图标" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, { size: "large" }, {
                      default: _withCtx(() => [
                        (addData.value.picture)
                          ? (_openBlock(), _createBlock(_component_a_image, {
                              key: 0,
                              src: addData.value.picture,
                              width: "80px"
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true),
                        _createVNode(PictureUpload, {
                          biz: "bank_icon",
                          modelValue: addData.value.picture,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((addData.value.picture) = $event)),
                          onChange: (url) => (addData.value.picture = url)
                        }, null, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: addSubmit
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 添加")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_a_modal, {
        visible: updateVisible.value,
        "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((updateVisible).value = $event)),
        draggable: "",
        footer: false
      }, {
        title: _withCtx(() => [
          _createTextVNode(" 添加题库")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_a_form, { model: oldData.value }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, { label: "标题" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      modelValue: oldData.value.title,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((oldData.value.title) = $event)),
                      placeholder: "请输入标题...",
                      "allow-clear": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "描述" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_textarea, {
                      modelValue: oldData.value.description,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((oldData.value.description) = $event)),
                      placeholder: "请输入描述...",
                      "allow-clear": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "题目图标" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, { size: "large" }, {
                      default: _withCtx(() => [
                        (oldData.value.picture)
                          ? (_openBlock(), _createBlock(_component_a_image, {
                              key: 0,
                              src: oldData.value.picture,
                              width: "80px"
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true),
                        _createVNode(PictureUpload, {
                          biz: "bank_icon",
                          modelValue: oldData.value.picture,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((oldData.value.picture) = $event)),
                          onChange: (url) => (oldData.value.picture = url)
                        }, null, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: updateSubmit
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 修改")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_a_modal, {
        visible: manageVisible.value,
        "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((manageVisible).value = $event)),
        draggable: "",
        footer: false
      }, {
        title: _withCtx(() => [
          _createTextVNode(" 管理题库")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_a_transfer, {
              "show-search": "",
              data: allList.value,
              "model-value": existList.value,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((existList).value = $event)),
              "one-way": "",
              "source-input-search-props": {
            placeholder: '搜索不存在的题目',
          },
              "target-input-search-props": {
            placeholder: '搜索已存在的题目',
          },
              title: ['不存在的题目', '已存在的题目']
            }, null, 8, ["data", "model-value"]),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (allSave())),
              style: {"margin":"20px 0 0 200px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 保存 ")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_a_modal, {
        visible: manageVisible.value,
        "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((manageVisible).value = $event)),
        draggable: "",
        footer: false
      }, {
        title: _withCtx(() => [
          _createTextVNode(" 排序题目")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_a_transfer, {
              "show-search": "",
              data: allList.value,
              "model-value": existList.value,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((existList).value = $event)),
              "one-way": "",
              "source-input-search-props": {
            placeholder: '搜索不存在的题目',
          },
              "target-input-search-props": {
            placeholder: '搜索已存在的题目',
          },
              title: ['不存在的题目', '已存在的题目']
            }, null, 8, ["data", "model-value"]),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (allSave())),
              loading: batchLoading.value,
              style: {"margin":"20px 0 0 200px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 保存 ")
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _createVNode(_component_a_table, {
      columns: columns,
      data: dataList.value,
      pagination: {
      showTotal: true,
      pageSize: searchParams.value.pageSize,
      current: searchParams.value.current,
      total: total.value,
    },
      stripe: true,
      bordered: { cell: true },
      onPageChange: onPageChange,
      loading: loading.value
    }, {
      picture: _withCtx(({ record }) => [
        _createVNode(_component_a_image, {
          width: "64",
          src: record.picture
        }, null, 8, ["src"])
      ]),
      reviewStatus: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(REVIEW_STATUS_MAP)[record.reviewStatus]), 1)
      ]),
      reviewTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(dayjs)(record.reviewTime).format("YYYY-MM-DD")), 1)
      ]),
      createTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(dayjs)(record.createTime).format("YYYY-MM-DD")), 1)
      ]),
      updateTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(dayjs)(record.updateTime).format("YYYY-MM-DD")), 1)
      ]),
      optional: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "outline",
              status: "success",
              onClick: ($event: any) => (manageBank(record.id))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 管理 ")
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_button, {
              type: "outline",
              status: "success",
              onClick: ($event: any) => (orderBank(record.id))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 排序 ")
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_button, {
              type: "outline",
              onClick: ($event: any) => (update(record.id))
            }, {
              default: _withCtx(() => [
                _createTextVNode("修改")
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_button, {
              type: "outline",
              status: "danger",
              onClick: ($event: any) => (doDelete(record.id))
            }, {
              default: _withCtx(() => [
                _createTextVNode("删除 ")
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 2
        }, 1024)
      ]),
      tags: _withCtx(({ record }) => [
        _createVNode(_component_a_space, { wrap: "" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.tags, (tag, index) => {
              return (_openBlock(), _createBlock(_component_a_tag, {
                key: index,
                color: "green"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tag), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data", "pagination", "loading"])
  ], 64))
}
}

})